/**
 * The view the board surface should render: a view TAB's own view (when one is
 * active) takes precedence over the HUD picker's manual pick. One source of
 * truth so the board projection, the representation switch, and the table/
 * matrix/flow containers all agree — without syncing global state (no effect,
 * so the picker's selection on a board tab is never clobbered by a tab switch).
 */
import { useWorkspace } from "../workbench/WorkspaceContext.js";
import { useActiveTabId, useTabs } from "../workbench/WorkspaceStore.js";
import { useActiveView } from "../workbench/ActiveViewContext.js";

export function useEffectiveViewName(): string | null {
  const store = useWorkspace();
  const tabs = useTabs(store);
  const activeTabId = useActiveTabId(store);
  const { activeViewName } = useActiveView();
  const activeTab = tabs.find((t) => t.id === activeTabId);
  return (activeTab?.kind === "view" ? activeTab.state.viewName : null) ?? activeViewName;
}
